/**
 * Created by Administrador on 10/12/2016.
 */
(function(){
    'use strict';

    var seat = {
        templateUrl: 'app/components/seatMap/seat.html',
        controller: seatController,
        controllerAs: 'vm',
        bindings:{
            seatData: '=',
            seatIndex: '=',
            cabinIndex: '=',
            categoryCode: '@',
            onUpdateSeat: '&',
            onEditSeat: '&',
            onDeleteSeat: '&'
        }
    }

    angular
        .module('completeAir')
        .component('seat', seat);

    seatController.$inject = ['$element'];

    function seatController($element){

        var vm = this;
        var elemJQLegend = $element.find("div.seat");
        vm.seat = vm.seatData;

        vm.$postLink = function(){

            var $drag = elemJQLegend.draggable({
                containment: "#cabinSeat" + vm.cabinIndex,
                grid: [5, 5]
            });

            $drag.on( "dragstop", function( event, ui ) {
                vm.seat.left = ui.position.left;
                vm.seat.top = ui.position.top;
                vm.onUpdateSeat({$event: {value: vm.seatIndex}}, {$event: {value: vm.seat}});
            });
        }

        vm.editCabinToSeat = function(){
            vm.onEditSeat({$event: {value: vm.seatIndex}}, {$event: {value: vm.cabinIndex}});
        }

        vm.deleteCabinToSeat = function(){
            vm.onDeleteSeat({$event: {value: vm.seatIndex}}, {$event: {value: vm.cabinIndex}});
        }
    }

})();
